import { fetchJson } from '~/utils/fetch-json-v2';
import type { BalanceResponse } from '../../(payment-methods)/-types/account';
import type { Transaction } from '../../(payment-methods)/cards/-types/card';

export async function getBalancesAggregatedApi() {
  return fetchJson<BalanceResponse>('/accounts/balances');
}

export async function getTransactionsAggregatedApi(
  asset: string,
  direction?: 'in' | 'out',
) {
  const params = new URLSearchParams({ asset });
  if (direction) {
    params.append('direction', direction);
  }

  return fetchJson<{ transactions: Transaction[] }>(
    `/accounts/transactions?${params.toString()}`,
  );
}
